// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__UNss7","name":"ConsentHeader_name__1ca9O","birthday":"ConsentHeader_birthday__2CO8F","skeleton":"ConsentHeader_skeleton__3G9NN"};